import { Component, ViewChild } from "@angular/core";
import { LegalCoverDesktopBenefitsDrawerComponent } from "./Benefits/desktop-benefits-drawer/legalCoverDesktopBenefitsDrawer.component";
import { LegalCoverMobileBenefitsDrawerComponent } from "./Benefits/mobile-benefits-drawer/legalCoverMobileBenefitsDrawer.component";
import { LegalCoverDesktopPremiumDrawerComponent } from "./Premium/desktop-premium-drawer/legalCoverDesktopPremiumDrawer.component";
import { LegalCoverMobilePremiumDrawerComponent } from "./Premium/mobile-premium-drawer/legalCoverMobilePremiumDrawer.component";
import { InsuranceHubService } from "src/app/services/Insurance-hub.service";
import { InsuranceHubBaseComponent } from "../Insurance-hub-callback";
import { RouterModule } from "@angular/router";
@Component({
  selector: "app-credit-life",
  templateUrl: "./legal-cover.component.html",
  styleUrls: ["./legal-cover.component.css"],
  standalone: true,
  imports: [
    LegalCoverDesktopBenefitsDrawerComponent,
    LegalCoverMobileBenefitsDrawerComponent,
    LegalCoverDesktopPremiumDrawerComponent,
    LegalCoverMobilePremiumDrawerComponent,
    RouterModule
  ],
})
export class LegalCoverComponent extends InsuranceHubBaseComponent {
  @ViewChild("legalCoverDesktopBenefitsDrawerComponent")
  legalCoverDesktopBenefitsDrawerComponent!: LegalCoverDesktopBenefitsDrawerComponent;
  @ViewChild("legalCoverMobileBenefitsDrawerComponent")
  legalCoverMobileBenefitsDrawerComponent!: LegalCoverMobileBenefitsDrawerComponent;

  @ViewChild("legalCoverDesktopPremiumDrawerComponent")
  legalCoverDesktopPremiumDrawerComponent!: LegalCoverDesktopPremiumDrawerComponent;
  @ViewChild("legalCoverMobilePremiumDrawerComponent")
  legalCoverMobilePremiumDrawerComponent!: LegalCoverMobilePremiumDrawerComponent;

  private offcanvasInstances: { [key: string]: any } = {};

  drawerContent;

  ngOnInit(): void {
    this.GetPolicyDetailData();
  }

  GetPolicyDetailData() {
    let uPolicyData = sessionStorage.getItem("UserPolicyDetails")
      ? JSON.parse(sessionStorage.getItem("UserPolicyDetails"))
      : null;
    if (uPolicyData?.legalCoverPolicyResponse) {
      this.PolicyDetailResponse = uPolicyData.legalCoverPolicyResponse;
    }
  }
  openLegalCoverBenefitsDesktopDrawer() {
    this.legalCoverDesktopBenefitsDrawerComponent.openDrawer(
      this.PolicyDetailResponse
    );
  }

  openLegalCoverBenefitsMobileDrawer() {
    this.legalCoverMobileBenefitsDrawerComponent.openDrawer(
      this.PolicyDetailResponse
    );
  }

  openLegalCoverDesktopPremiumDrawer() {
    this.legalCoverDesktopPremiumDrawerComponent.openDrawer(
      this.PolicyDetailResponse
    );
  }

  openLegalCoverMobilePremiumDrawer() {
    this.legalCoverMobilePremiumDrawerComponent.openDrawer(
      this.PolicyDetailResponse
    );
  }
}
